<template>
  <div class="chart-background">
    <div class="row chart-row">
      <div class="col-lg-12 chart-col">
        <panel-svg></panel-svg>
        <div id="panel" class="chart-block" style="height: 110px"></div>
      </div>
    </div>
    <div class="row chart-row">
      <div class="col-lg-8 chart-col">
        <div id="system" class="chart-block">
          <div
            id="cpu"
            class="col-lg-4 chart-col chart-sub-block"
            style="height: 170px"
          ></div>
          <div
            id="mem"
            class="col-lg-4 chart-col chart-sub-block"
            style="height: 170px"
          ></div>
          <div
            id="temp"
            class="col-lg-4 chart-col chart-sub-block"
            style="height: 170px"
          ></div>
        </div>
      </div>
      <div class="col-lg-4 chart-col">
        <div id="systeminfo" class="chart-block" style="height: 170px"></div>
      </div>
    </div>
    <div class="row chart-row">
      <div class="col-lg-8 chart-col">
        <div id="ont" class="chart-block" style="height: 400px"></div>
      </div>
      <div class="col-lg-4 chart-col">
        <div id="uplinkutil" class="chart-block" style="height: 400px"></div>
      </div>
    </div>
    <info-box :ibox="iBox"></info-box>
  </div>
</template>
<script>
import InfoBox from "./../components/InfoBox.vue"
import PanelSvg from "../components/PanelSvg.vue"
import * as echarts from "echarts"
import { get, post } from "@/utils/http.js"
import axios from "axios"
export default {
  name: "home",
  components: {
    InfoBox,
    PanelSvg,
  },
  data() {
    return {
      iBox: {},
      updateHandle: null,
      statusData: null,
      systemInfoData: null,
      ontCountData: null,
      upLinkUtilData: null,
    }
  },
  created() {},
  beforeDestroy() {
    clearInterval(this.updateHandle)
  },
  mounted() {
    this.init()
    this.updateHandle = window.setInterval(this.init, 3000)
  },
  watch: {
    statusData() {
      if (this.statusData) this.drawPanel()
    },
    systemInfoData() {
      if (this.systemInfoData) {
        this.drawCpu()
        this.drawMem()
        this.drawTemp()
        this.drawSystemInfo()
      }
    },
    ontCountData() {
      if (this.ontCountData) this.drawOnt()
    },
    upLinkUtilData() {
      if (this.upLinkUtilData) this.drawUplinkUtil()
    },
  },
  methods: {
    init() {
      this.pannelInit()
      this.systemInfoInit()
      this.ontCountInit()
      this.uplinkUtilInit()
    },
    pannelInit() {
      get("panelStatus")
        .then((res) => {
          this.statusData = res.data
        })
        .catch((err) => {})
    },
    systemInfoInit() {
      get("systemInfo")
        .then((res) => {
          this.systemInfoData = res.data
        })
        .catch((err) => {})
    },
    ontCountInit() {
      get("ontCount")
        .then((res) => {
          this.ontCountData = res.data
        })
        .catch((err) => {})
    },
    uplinkUtilInit() {
      get("uplinkUtil")
        .then((res) => {
          this.upLinkUtilData = res.data
        })
        .catch((err) => {})
    },
    drawOnt() {
      var myChart = echarts.init(document.getElementById("ont"))
      var ontCountData0 = this.ontCountData
      ontCountData0.forEach((element) => {
        if (element[0] !== "port" && element[0].slice(0, 3) === "g0/")
          element[0] = "P" + element[0].slice(3)
      })
      var ontCountData1 = [
        [ontCountData0[0][1], 0],
        [ontCountData0[0][2], 0],
      ]
      ontCountData0.forEach((element) => {
        if (element[0] !== "port") {
          ontCountData1[0][1] += element[1]
          ontCountData1[1][1] += element[2]
        }
      })
      var ontCountData2 = [
        [
          0,
          0,
          ontCountData1[0][0],
          ontCountData1[0][1].toLocaleString(),
          ontCountData1[1][0],
          ontCountData1[1][1].toLocaleString(),
          "total",
          (ontCountData1[0][1] + ontCountData1[1][1]).toLocaleString(),
        ],
      ]
      var labelOption = {
        show: true,
        rotate: 0,
        position: "insideBottom",
        distance: 15,
        verticalAlign: "middle",
        fontSize: 16,
      }

      var option = {
        dataset: [
          {
            //source: ontCountData0
            source: ontCountData0.map((v) =>
              v.map((vi) => (vi === 0 ? null : vi))
            ),
          },
          {
            source: ontCountData1,
          },
          { source: ontCountData2 },
        ],
        title: {
          text: "ONT Statistics",
          //subtext: "",
          top: 10,
          left: "30%",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          //renderMode: "richText",
          formatter: function (params) {
            var dataIndex = 1 + params[0].seriesIndex

            if (!params.length) return
            if (params[0].value[dataIndex] == null)
              params[0].value[dataIndex] = 0
            if (params.length > 1)
              if (params[1].value[2] == null) params[1].value[2] = 0

            var tip = []
            var divRow = "<div style='margin-top:3px'>"
            var spanName = "<span style='margin-left: 2px; margin-right:20px'>"
            var spanValue =
              "</span><span style='font-weight: bold; display:inline-block; float:right;'>"
            tip.push("<span>" + params[0].value[0] + "</span>")
            tip.push(
              divRow +
                params[0].marker +
                spanName +
                params[0].seriesName +
                spanValue +
                params[0].value[dataIndex].toLocaleString() +
                "</span></div>"
            )
            if (params.length > 1) {
              tip.push(
                divRow +
                  params[1].marker +
                  spanName +
                  params[1].seriesName +
                  spanValue +
                  params[1].value[2].toLocaleString() +
                  "</span></div>"
              )
              tip.push(
                divRow +
                  spanName +
                  "total" +
                  spanValue +
                  (params[0].value[1] + params[1].value[2]).toLocaleString() +
                  "</span></div>"
              )
            }
            return tip.join("")
          },
          //backgroundColor: "#fff",
          //borderColor: "#bbb",
          //borderWidth: 1,
          //borderRadius: 4,
        },
        legend: { top: 10, left: "60%" },
        toolbox: {
          show: true,
          orient: "horizontal",
          right: "20",
          top: 10,
          feature: {
            mark: { show: true },
            dataView: {
              show: true,
              readOnly: true,
              lang: ["ONT online and offline", "close"],
              optionToContent: function (opt) {
                var data = ontCountData0
                var table =
                  '<table style="width:60%;text-align:center; color:#000"><tbody>'
                for (var i = 0, l = data.length; i < l; i++) {
                  table +=
                    "<tr" +
                    (!i ? " style='font-weight: bold'" : "") +
                    ">" +
                    "<td>" +
                    data[i][0] +
                    "</td>" +
                    "<td>" +
                    (data[i][1] === null ? 0 : data[i][1]) +
                    "</td>" +
                    "<td>" +
                    (data[i][2] === null ? 0 : data[i][2]) +
                    "</td>" +
                    "</tr>"
                }
                table += "</tbody></table>"
                return table
              },
            },
            //magicType: { show: true, type: ["line", "bar", "stack", "tiled"] },
            //restore: { show: true },
            //saveAsImage: { show: true },
          },
        },
        grid: [
          { left: 50, right: 150, bottom: 40 },
          { right: 0, width: 145, bottom: 40, height: 0 },
        ],
        xAxis: [
          {
            type: "category",
            axisLabel: { interval: 0, rotate: 0 },
            axisTick: { show: false },
          },
          {
            axisLabel: { show: false },
            axisLine: { show: false },
            splitLine: { show: false },
            axisTick: { show: false },
            min: -1,
            max: 1,
            gridIndex: 1,
          },
        ],
        yAxis: [
          {
            type: "value",
            minInterval: 5,
          },
          {
            axisLabel: { show: false },
            axisLine: { show: false },
            splitLine: { show: false },
            axisTick: { show: false },
            min: -1,
            max: 1,
            gridIndex: 1,
          },
        ],
        label: labelOption,
        color: ["#32bd32", "#df4500"],
        barWidth: 30,
        series: [
          {
            type: "bar",
            //seriesLayoutBy: "row",
            stack: "total",
            //barGap: 0,
            barMinHeight: 5,
            label: { rotate: 45, formatter: "{@[1]}" },
            emphasis: {
              focus: "series",
            },
          },
          {
            type: "bar",
            //seriesLayoutBy: "row",
            stack: "total",
            //barGap: 0,
            barMinHeight: 5,
            label: { distance: 35, rotate: 45, formatter: "{@[2]}" },
            emphasis: {
              focus: "series",
            },
          },
          {
            type: "pie",
            radius: "25%",
            center: ["91%", "28%"],
            tooltip: {
              trigger: "item",
              formatter: function (params) {
                return (
                  params.marker +
                  "<span style='margin-left: 2px; margin-right: 20px;'>" +
                  params.value[0] +
                  ":</span><span style='font-weight: bold'>" +
                  params.value[1].toLocaleString() +
                  "</span>"
                )
              },
            },
            label: {
              position: "inside",
              formatter: function (params) {
                return params.value[1] ? params.value[1].toLocaleString() : ""
              },
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            datasetIndex: 1,
          },
          {
            type: "scatter",
            symbolSize: 0,
            symbol: "roundRect",

            xAxisIndex: 1,
            yAxisIndex: 1,
            label: {
              formatter: [
                "{title|Count}{tbg|}",
                "  {r1|}{name|{@[2]}:}{value|{@[3]}}",
                "  {r2|}{name|{@[4]}:}{value|{@[5]}}",
                "  {r3|}{name|{@[6]}:}{value|{@[7]}}",
              ].join("\n"),
              position: "top",
              distance: 130,
              backgroundColor: "#fff",
              borderColor: "#787",
              borderWidth: 1,
              borderRadius: 4,
              shadowBlur: 5,
              shadowColor: "#787",
              rich: {
                title: {
                  color: "#fff",
                  align: "center",
                  fontWeight: "bold",
                  fontSize: 14,
                },
                tbg: {
                  backgroundColor: "#044",
                  width: "100%",
                  align: "right",
                  height: 25,
                  borderRadius: [4, 4, 0, 0],
                },
                r1: {
                  height: 25,
                  align: "left",
                  backgroundColor: {},
                },
                r2: {
                  height: 25,
                  align: "left",
                  backgroundColor: {},
                },
                r3: {
                  height: 25,
                  align: "left",
                  backgroundColor: {},
                },
                name: {
                  width: 20,
                  padding: [0, 25, 0, 0],
                  align: "left",
                  //fontWeight: "bold",
                  fontSize: 14,
                },
                value: {
                  width: 25,
                  padding: [0, 25, 0, 25],
                  align: "left",
                  fontWeight: "bold",
                  fontSize: 14,
                },
              },
            },
            datasetIndex: 2,
          },
        ],
      }

      option && myChart.setOption(option)
      myChart.resize()
      myChart.off("click")
      myChart.on("click", (event) => {
        if (event.seriesIndex === 2) this.$router.push("/ontbrief")
        else if (event.seriesIndex < 2 && event.seriesIndex >= 0)
          this.$router.push({
            name: "ontbrief",
            params: {
              searchType: "pon",
              searchInfo: "0/" + event.name.slice(1),
            },
          })
      })
    },
    drawUplinkUtil() {
      var myChart = echarts.init(document.getElementById("uplinkutil"))
      var labelOption = {
        show: true,
        rotate: 90,
        position: "insideBottom",
        distance: 10,
        align: "left",
        verticalAlign: "middle",
        fontSize: 16,
      }
      var option = {
        dataset: [
          {
            //source: this.upLinkUtilData,
            source: this.upLinkUtilData.map((v) =>
              v.map((vi) => (vi === 0 ? null : vi))
            ),
          },
        ],
        title: {
          text: "Uplink Utilization",
          //subtext: "",
          top: 10,
          left: "30%",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          formatter: function (params) {
            var dataIndex = 1 + params[0].seriesIndex

            if (!params.length) return
            if (params[0].value[dataIndex] == null)
              params[0].value[dataIndex] = 0

            var tip = []
            var divRow = "<div style='margin-top:3px'>"
            var spanName = "<span style='margin-left: 2px; margin-right:20px'>"
            var spanValue =
              "</span><span style='font-weight: bold; display:inline-block; float:right;'>"
            tip.push("<span>" + params[0].value[0] + "</span>")
            tip.push(
              divRow +
                params[0].marker +
                spanName +
                params[0].seriesName +
                spanValue +
                params[0].value[dataIndex].toLocaleString() +
                (params[0].seriesIndex === 2 || params[0].seriesIndex === 5
                  ? "%"
                  : "") +
                "</span></div>"
            )
            return tip.join("")
          },
        },
        legend: { top: 40, selectedMode: "single" },
        toolbox: {
          show: true,
          orient: "horizontal",
          right: "20",
          top: 10,
          feature: {
            mark: { show: true },
            dataView: {
              show: false,
              readOnly: true,
              lang: ["Uplink port utilization", "close"],
            },
            //magicType: { show: true, type: ["line", "bar", "stack", "tiled"] },
            //restore: { show: true },
            //saveAsImage: { show: true },
          },
        },
        grid: { left: 20, right: 100, top: 110, bottom: 40 },
        xAxis: [
          {
            type: "category",
            axisLabel: { interval: 0, rotate: 0 },
            axisTick: { show: false },
          },
        ],
        yAxis: [
          {
            type: "value",
            position: "right",
            minInterval: 1,
          },
        ],
        label: labelOption,
        barWidth: "50%",
        series: [
          {
            type: "bar",
            // eriesLayoutBy: "row",
            // barGap: 0,
            barMinHeight: 5,
            emphasis: {
              focus: "series",
            },
          },
          {
            type: "bar",
            // seriesLayoutBy: "row",
            // barGap: 0,
            barMinHeight: 5,
            emphasis: {
              focus: "series",
            },
          },
          {
            type: "bar",
            // seriesLayoutBy: "row",
            // barGap: 0,
            barMinHeight: 5,
            emphasis: {
              focus: "series",
            },
          },
          {
            type: "bar",
            // seriesLayoutBy: "row",
            // barGap: 0,
            barMinHeight: 5,
            emphasis: {
              focus: "series",
            },
          },
          {
            type: "bar",
            // seriesLayoutBy: "row",
            // barGap: 0,
            barMinHeight: 5,
            emphasis: {
              focus: "series",
            },
          },
          {
            type: "bar",
            // seriesLayoutBy: "row",
            // barGap: 0,
            barMinHeight: 5,
            emphasis: {
              focus: "series",
            },
          },
        ],
      }

      option && myChart.setOption(option)
      myChart.resize()
    },
    drawCpu() {
      var myChart = echarts.init(document.getElementById("cpu"))
      var option = {
        dataset: [
          {
            source: [[]],
          },
        ],
        title: {
          text: "CPU Idle",
          //subtext: "",
          bottom: 3,
          left: "33%",
        },
        tooltip: {},
        series: [
          {
            type: "pie",
            radius: ["50%", "60%"],
            center: ["50%", "45%"],
            color: [this.systemInfoData.cpuIsBusy ? "#c00" : "#4a4", "#ccc"],
            tooltip: {
              trigger: "item",
              formatter: function (params) {
                return (
                  params.marker +
                  "<span style='margin-left: 2px; margin-right: 20px;'>" +
                  params.name +
                  ":</span><span style='font-weight: bold'>" +
                  params.value.toLocaleString() +
                  "%" +
                  "</span>"
                )
              },
            },
            data: [
              {
                name: "Idle",
                value: this.systemInfoData.cpuIdle,
                label: {
                  position: "center",
                  fontSize: 20,
                  fontWeight: "bold",
                  formatter: "{d}%",
                },
              },
              {
                name: "Used",
                value: 100 - this.systemInfoData.cpuIdle,

                label: { show: false },
              },
            ],

            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      }
      option && myChart.setOption(option)
      myChart.resize()
    },
    drawMem() {
      var myChart = echarts.init(document.getElementById("mem"))
      var option = {
        dataset: [
          {
            source: [[]],
          },
        ],
        title: {
          text: "Memory Free",
          //subtext: "",
          bottom: 3,
          left: "25%",
        },
        color: ["#4a4", "#ccc"],
        tooltip: {},
        series: [
          {
            type: "pie",
            radius: ["50%", "60%"],
            center: ["50%", "45%"],
            tooltip: {
              trigger: "item",
              formatter: function (params) {
                return (
                  params.marker +
                  "<span style='margin-left: 2px; margin-right: 20px;'>" +
                  params.name +
                  ":</span><span style='font-weight: bold'>" +
                  params.value.toLocaleString() +
                  " MB" +
                  "</span>"
                )
              },
            },
            data: [
              {
                name: "Free",
                value: this.systemInfoData.memFree,
                label: {
                  position: "center",
                  fontSize: 20,
                  fontWeight: "bold",
                  formatter: ["{c} {unit|MB}"].join("\n"),
                  rich: {
                    unit: {
                      fontSize: 12,
                      fontWeight: "bold",
                      color: "#888",
                      height: 25,
                    },
                  },
                },
              },
              {
                name: "Used",
                value:
                  this.systemInfoData.memSize - this.systemInfoData.memFree,
                label: { show: false },
              },
            ],

            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      }
      option && myChart.setOption(option)
      myChart.resize()
    },
    drawTemp() {
      var myChart = echarts.init(document.getElementById("temp"))
      var myChart = echarts.init(document.getElementById("temp"))
      var tempTitle =
        this.systemInfoData.temp < this.systemInfoData.tempThLow
          ? "Low"
          : this.systemInfoData.temp > this.systemInfoData.tempThHigh
          ? "High"
          : "Normal"
      var option = {
        dataset: [
          {
            source: [[]],
          },
        ],
        title: {
          text: "Temperature",
          //subtext: "",
          bottom: 3,
          left: "15%",
        },
        legend: {
          show: false,
          selectedMode: false,
          orient: "vertical",
          icon: "circle",
          top: "5%",
          right: "2%",
          itemWidth: 10,
          itemHeight: 10,
          label: { formatter: "{a}" },
        },
        grid: {
          z: 1,
          show: false,
          width: "0%",
          right: "27%",
          height: "25%",
          bottom: "60%",
          containLabel: true,
          splitLine: { show: false },
        },
        xAxis: [
          {
            type: "value",
            axisLine: { show: false },
            splitLine: { show: false },
            splitArea: { interval: "auto", show: false },
            axisLabel: { show: false },
            axisTick: { show: false },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLine: { show: false },
            splitLine: { show: false },
            axisLabel: { show: false },
            axisTick: { show: false },
          },
        ],
        tooltip: {},
        label: {
          show: true,
          position: "right",
          formatter: "{a}",
        },
        series: [
          {
            type: "gauge",
            radius: "80%",
            center: ["40%", "50%"],
            color:
              this.systemInfoData.temp < this.systemInfoData.tempThLow
                ? "#37a2da"
                : this.systemInfoData.temp > this.systemInfoData.tempThHigh
                ? "#fd666d"
                : "#4a4",
            min: -100,
            max: 100,
            splitNumber: 10,
            axisLine: {
              lineStyle: {
                width: 10,
                color: [
                  [(this.systemInfoData.tempThLow + 100) / 200, "#37a2da"],
                  [(this.systemInfoData.tempThHigh + 100) / 200, "#4a4"],
                  [1, "#fd666d"],
                ],
              },
            },
            tooltip: {
              trigger: "item",
              formatter: function (params) {
                return (
                  params.marker +
                  "<span style='margin-left: 2px; margin-right: 20px;'>" +
                  tempTitle +
                  ":</span><span style='font-weight: bold'>" +
                  params.value.toLocaleString() +
                  " °C" +
                  "</span>"
                )
              },
            },
            pointer: {
              icon: "path://M12.8,0.7l12,40.1H0.7L12.8,0.7z",
              length: "12%",
              width: 10,
              offsetCenter: [0, "-50%"],
              itemStyle: {
                color: "auto",
              },
            },
            axisTick: {
              distance: -10,
              length: 3,
              lineStyle: {
                color: "#ccc",
                width: 2,
              },
            },
            splitLine: {
              distance: -10,
              length: 10,
              lineStyle: {
                color: "#ccc",
                width: 2,
              },
            },
            axisLabel: {
              color: "auto",
              distance: 12,
              fontSize: 12,
            },
            detail: {
              valueAnimation: true,
              formatter: "{value} {unit|°C}",
              rich: {
                unit: {
                  color: "#888",
                  fontSize: 12,
                  fontWeight: "bold",
                  height: 25,
                },
              },
              color: "auto",
              fontSize: 20,
              offsetCenter: ["5%", "0%"],
            },
            data: [
              {
                value: this.systemInfoData.temp,
              },
            ],
          },
          {
            name: "Low",
            type: "scatter",

            data: [[0, 2]],
            itemStyle: { color: "#37a2da", opacity: 1 },
            tooltip: {
              formatter: " < " + this.systemInfoData.tempThLow + "°C",
            },
          },
          {
            name: "Normal",
            type: "scatter",

            data: [[0, 1, "ss"]],
            itemStyle: { color: "#4a4", opacity: 1 },
            tooltip: {
              formatter:
                this.systemInfoData.tempThLow +
                "°C ~ " +
                this.systemInfoData.tempThHigh +
                "°C",
            },
          },
          {
            name: "High",
            type: "scatter",

            data: [[0, 0]],
            itemStyle: { color: "#fd666d", opacity: 1 },
            tooltip: {
              formatter: " > " + this.systemInfoData.tempThHigh + "°C",
            },
          },
        ],
      }
      option && myChart.setOption(option)
      myChart.resize()
    },
    drawSystemInfo() {
      var myChart = echarts.init(document.getElementById("systeminfo"))
      var option = {
        dataset: [
          {
            source: [[]],
          },
        ],
        title: {
          text: "System Information",
          //subtext: "",
          top: 5,
          left: "25%",
        },
        grid: {
          z: 1,
          show: false,
          left: "0%",
          //right: "0%",
          //top: "0%",
          //bottom: "50%",
          //containLabel: true,
        },
        xAxis: [
          {
            type: "value",
            axisLine: { show: false },
            splitLine: { show: false },
            splitArea: { interval: "auto", show: false },
            axisLabel: { show: false },
            axisTick: { show: false },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLine: { show: false },
            splitLine: { show: false },
            axisLabel: { show: false },
            axisTick: { show: false },
          },
        ],
        label: {
          show: true,
          position: "right",
          distance: -15,
          formatter: [
            "{key|Software version}{value|" +
              this.systemInfoData.version.split(" ").slice(-1) +
              "}",
            "{key|System object id}{value|" + this.systemInfoData.oid + "}",
            "{key|System run time}{value|" + this.systemInfoData.runTime + "}",
            "{key|Processor}{value|" + this.systemInfoData.processor + "}",
          ].join("\n"),
          rich: {
            key: {
              width: 115,
              height: 22,
              fontWeight: "bold",
              fontSize: 12,
              color: "#888",
              padding: [0, 10, 0, 30],
              align: "left",
            },
            value: { width: 30, fontSize: 12, color: "#888" },
          },
        },
        series: [
          {
            name: "Hide",
            type: "scatter",
            symbolSize: 0,
            data: [[0, 0]],
            itemStyle: { color: "#fd666d", opacity: 1 },
          },
        ],
      }

      option && myChart.setOption(option)
      myChart.resize()
    },
    drawPanel() {
      var myChart = echarts.init(document.getElementById("panel"))
      echarts.registerMap("Panel", {
        svg: document.getElementById("svg_panel"),
      })

      function makeStatusRegions(statusData) {
        var regions = []
        var port = statusData.port
        var css1 = "<span style='display:inline-block; width: 70px;'>"
        var css2 = "</span><span style='font-weight: bold'>"
        var up = {
          color: "#33ff33",
          borderColor: "#0a0",
        }
        var down = {
          color: "#333",
          borderColor: "#333",
        }
        var ponBlk2 = false
        var ponBlk3 = false
        var ponBlk4 = false

        for (var i = 0; i < port.length; i++) {
          if (port[i].name === "g0/5") ponBlk2 = true
          if (port[i].name === "g0/9") ponBlk3 = true
          if (port[i].name === "g0/13") ponBlk4 = true
          var combo =
            port[i].name === "e1/1" ||
            port[i].name === "e1/2" ||
            port[i].name === "e1/3" ||
            port[i].name === "e1/4"
              ? true
              : false

          var tip = {
            formatter: [
              port[i].name,
              css1 + "status:" + css2 + (port[i].link ? "linkup" : "linkdown"),
            ].join("</span><br>"),
          }
          var region = {
            name: port[i].name,
            itemStyle: {},
            tooltip: tip,
            itemStyle: port[i].link && (!combo || !port[i].sfp) ? up : down,
          }
          regions.push(region)

          if (combo)
            regions.push({
              name: port[i].name + "_sfp",
              tooltip: tip,
              itemStyle: port[i].link && (!combo || port[i].sfp) ? up : down,
            })
        }

        if (!ponBlk4)
          document.getElementById("pon_block4").style.display = "none"
        if (!ponBlk3)
          document.getElementById("pon_block3").style.display = "none"
        if (!ponBlk2)
          document.getElementById("pon_block2").style.display = "none"

        for (var p = 0; p < 2; p++) {
          if (!statusData.power[p].insert)
            document.getElementById("power" + (p + 1)).style.display = "none"
          else {
            var powerTip = {
              formatter: [
                statusData.power[p].name,
                css1 +
                  "status:" +
                  css2 +
                  (statusData.power[p].good ? "Good" : "Bad"),
              ].join("</span><br>"),
            }
            regions.push({
              name: statusData.power[p].name,
              tooltip: powerTip,
              itemStyle: {},
            })
            regions.push({
              name: "led_" + statusData.power[p].name,
              tooltip: powerTip,
              itemStyle: { color: statusData.power[p].good ? "#0f0" : "red" },
            })
          }
        }

        var running =
          statusData.fan.insert &&
          (statusData.fan.speed[0] > 0 ||
            statusData.fan.speed[1] > 0 ||
            statusData.fan.speed[2] > 0)
        var fanTip = {
          formatter: [
            statusData.fan.name,
            css1 + "status:" + css2 + (running ? "Running" : "Stop"),
            /*
            css1 + "fan1:" + css2 + statusData.fan.speed[0] + " RPM",
            css1 + "fan2:" + css2 + statusData.fan.speed[1] + " RPM",
            css1 + "fan3:" + css2 + statusData.fan.speed[2] + " RPM",
            */
          ].join("</span><br>"),
        }
        regions.push({
          name: statusData.fan.name,
          tooltip: fanTip,
          itemStyle: {},
        })
        regions.push({
          name: "led_" + statusData.fan.name,
          tooltip: fanTip,
          itemStyle: {
            color: running ? "#0f0" : "red",
          },
        })

        return regions
      }
      var option = {
        tooltip: { position: "bottom" },

        geo: [
          {
            name: "Panel",
            map: "Panel",
            width: 1000,
            height: 90,

            emphasis: {
              label: {
                show: false,
              },
              itemStyle: {
                color: undefined, //"#E0FFFF",
              },
            },
            /*
            selectedMode: true,
            select: {
              itemStyle: {
                color: "#00f",
              },
              label: {
                show: false,
              },
            },
            itemStyle: {
              color: "auto",
            },
            */

            regions: makeStatusRegions(this.statusData),
          },
        ],
      }

      option && myChart.setOption(option)
      myChart.resize()
      return
    },

    /* 告警弹框 */
    showAlertBox(type, title, txt) {
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },
  },
}
</script>
<style scoped>
.chart-background {
  background-color: rgba(0, 107, 107, 0.1);
  position: absolute;
  left: 0%;
  right: 0%;
  overflow-x: hidden;
  overflow-y: hidden;
}
.chart-row {
  margin-left: 0px;
  margin-right: 0px;
}
.chart-col {
  padding: 0px;
}
.chart-block {
  margin-left: 1px;
  margin-right: 1px;
  margin-top: 1px;
  margin-bottom: 1px;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: rgba(52, 50, 57, 0.1) 0px 0px 20px;
}
.chart-sub-block {
  margin-left: 0px;
  margin-right: 0px;
  margin-top: 0px;
  margin-bottom: 0px;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: rgba(52, 50, 57, 0.1) 0px 0px 20px;
}
</style>
